// Direct replacement for react-doc-viewer/build/utils/importMeta.js
export var getMetaURL = function () {
  return typeof window !== 'undefined' ? window.location.href : '';
};

// Also export a default for modules that might use it
export default {
  getMetaURL: function () {
    return typeof window !== 'undefined' ? window.location.href : '';
  }
};